import "./style.scss"
import Header from "../header/Heade";
import Navbar from "../Navbar/Navbar";
import {useNavigate} from "react-router-dom";
import Footer from "../footer/Footer";
import Slider from "react-slick/lib";
import React, {useContext, useEffect, useState} from "react";
import {MyContext} from "../App/App";
import axios from "axios";
import Aos from "aos";
import Seo from "../Seo";
import {GOOGLE_RATING, GOOGLE_REVIEWS, GOOGLE_URL} from "../../googleListing";


const Reviews = () => {
    let value = useContext(MyContext);
    const navigate = useNavigate();
    const [comments, setComments] = useState([])
    const [partners, setPartners] = useState([])
    const [contact, setContact] = useState("");
    const settingsPartners = {
        lazyLoad: false,
        slidesToShow: 5,
        dots: false,
        infinite: true,
        speed: 2000,
        autoplay: true,
        navs: true,
        slidesToScroll: 5,
        initialSlide: 5,
        responsive: [{
            breakpoint: 1024, settings: {
                slidesToShow: 5, slidesToScroll: 5, infinite: true, dots: false
            }
        }, {
            breakpoint: 600, settings: {
                slidesToShow: 3, slidesToScroll: 3, initialSlide: 3
            }
        }, {
            breakpoint: 480, settings: {
                slidesToShow: 3, slidesToScroll: 3
            }
        }]
    };

    useEffect(() => {
        axios.get(`${value.url}comment/`).then((response) => {
            setComments(response.data)
        });

        axios.get(`${value.url}partner/`).then((response) => {
            setPartners(response.data)
        });

        axios.get(`${value.url}contact/`).then((response) => {
            setContact(response.data[0])
        });

        Aos.init({duration: 1000});
    }, []);

    return <div className="reviews-container">
        {/* "leader auto ship llc reviews" had 520 impressions in 28 days (Search Console, 2026-10-19)
            and landed on the home page, so the title leads with that phrase and the rating. */}
        <Seo title={`Leader Auto Ship LLC Reviews | ${GOOGLE_RATING}★ from ${GOOGLE_REVIEWS} on Google`}
             description={`Leader Auto Ship LLC is rated ${GOOGLE_RATING} from ${GOOGLE_REVIEWS} Google reviews. Read what customers say about shipping their cars with us, then check our FMCSA licence yourself.`}
             path="/reviews"/>

        <header>
            <Header/>
            <Navbar/>
        </header>

        <main>
            <section className="header-content">
                <div className="home-sloy">
                    <div className="home_contents">
                        <div className="left_side">
                            <div className="text-wrapper">
                                <strong className="top-text">
                                    Logistics & Leader Auto Ship
                                </strong>
                                <h1 className="text-large">
                                    <p data-aos="zoom-in">LEADER AUTO SHIP LLC REVIEWS</p>
                                </h1>
                                <article className="des-text">
                                    Rated <b>{GOOGLE_RATING}</b> from {GOOGLE_REVIEWS} reviews on Google.{" "}
                                    <a href={GOOGLE_URL} target="_blank" rel="noopener noreferrer">Read them on
                                        Google</a>, and check our licence on the{" "}
                                    <a href="https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=USDOT&query_string=4232283"
                                       target="_blank" rel="noopener noreferrer">FMCSA record (USDOT 4232283)</a>.
                                </article>
                                <div className="buttons-home">
                                    <button onClick={() => navigate("/get-quote")} type="button"
                                            className="button-home">
                                        Get a quote
                                    </button>
                                    <a href={`tel:${contact.phone1}`} className="button-home">
                                        Call now
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="right_side">
                        </div>
                    </div>
                </div>
            </section>

            <section className="reviews-container">
                <strong className="main-title">
                    Explore Our Reviews!
                </strong>
                <h2 className="title was-h1">
                    See What Our Customers are Saying
                </h2>
                <div className="slider-box-reviews">
                    {comments.map((item, index) => {
                        return <div key={index} className={(index + 1) % 2 === 0 ? "review-large" : "review"}>
                            <div className="content">
                                <div className="header">
                                    <div className="left">
                                        <div className="name">
                                            <strong className="name-user">{item.name}</strong>
                                        </div>
                                    </div>
                                    <div className="google">
                                        <img src={item.image} alt="logo-reviews" loading="lazy"/>
                                    </div>
                                </div>
                                <div className="des">
                                    {item.comment}
                                </div>
                                <div className="stars">
                                    <img src="./images/star1.webp" alt="review"/>
                                    <img src="./images/star1.webp" alt="review"/>
                                    <img src="./images/star1.webp" alt="review"/>
                                    <img src="./images/star1.webp" alt="review"/>
                                    <img src="./images/star1.webp" alt="review"/>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </section>

            <section className="partners">
                <Slider {...settingsPartners}>
                    {partners.map((item, index) => {
                        return <div key={index} className="logo">
                            <img src={item.logo} alt="partners" loading="lazy"/>
                        </div>
                    })}
                </Slider>
            </section>
        </main>


        <footer>
            <Footer/>
        </footer>
    </div>
};

export default Reviews